<template>
  <Toast />
  <router-view />
</template>
